module.exports = __webpack_public_path__ + "images/welcome-ss2.jpg";